import { Interpolation, css, ThemeProps } from 'styled-components';

type KeyFn = ({ loop }) => string;
type ValueFn = ({ loop, key }) => string;

type KeyHandler = KeyFn | string | string[];
type ValueHandler = ValueFn | string | string[];

type Spec = {
  loop: string[];
  key: KeyHandler | KeyHandler[];
  value: ValueHandler | ValueHandler[];
};

type FnSpec = (props: any) => Spec | Spec;

type Specs = FnSpec | FnSpec[];

function getHandlerValue(params: any, value, idx: number): string | string[] {
  if (typeof value === 'string') return value;
  if (typeof value === 'function') return value(params);
  if (idx !== undefined) return getHandlerValue(params, value[idx], undefined);
  return value;
}

export default function styleGenerator(_specs: Specs) {
  const specs = Array.isArray(_specs) ? _specs : [_specs];
  return specs.map(_fnSpec => {
    const fnSpec = typeof _fnSpec === 'function' ? _fnSpec : () => _fnSpec;
    return css`
      ${props => {
        const { loop, key: keyHandlers, value: valueHandlers } = fnSpec(props);
        return loop.map((cLoop, idx) => {
          const _keys = getHandlerValue({ loop: cLoop }, keyHandlers, idx);
          const keys = Array.isArray(_keys) ? _keys : [_keys];
          if (props[cLoop] === undefined) return;
          return keys.map(key => {
            const value = getHandlerValue({ loop: cLoop, key }, valueHandlers, idx);
            return `${key}:${value};`;
          });
        });
      }}
    `;
  });
}
